import { gql } from '@apollo/client';

const SubscriptionInfoPublic = gql`
  fragment SubscriptionInfoPublic on Subscription {
    id
    name
    description
    hexCode
    startedAt
    endedAt
    firstPaymentAt
    lastPaymentAt
    renewalAt
    endedAt
    state
    unitsPerInterval
    planInterval
    consecutiveFailures
    lastFailedAt
    reminder1SentAt
    reminder2SentAt
    reminder3SentAt
    needsCreditCard
    needsUpdatedCard
    pausedAt
    pauseDuration
    pauseEndAt
    subscriptionPrice
    patient {
      id
      firstName
      lastName
    }
    account {
      id
      accountNumber
    }
    product {
      id
      name
      price
      description
      internalName
    }
    createdAt
    updatedAt
  }
`;

export default SubscriptionInfoPublic;
